import { gql } from './apollo';

export const GET_AUDITS_FOR_OBJECT_FILTERED_BY_OPERATION = gql`
    query ($objectId: String!, $operation: Operation) {
        allAudits(filters: { objectId: $objectId, operation: $operation }) {
            edges {
                node {
                    createdAt
                    objectId
                    operation
                    old
                    new
                }
            }
        }
    }
`;

export const GET_AUDIT_COUNT_FOR_OPERATION_GROUPED_BY_OBJECT = gql`
    query ($operation: String!, $objectIds: [String]!) {
        auditCountForOperationGroupedByObject(operation: $operation, objectIds: $objectIds)
    }
`;
